import React, { FunctionComponent } from 'react';
import { Breakpoint } from '@noths/polaris-client-ribbons-base';
import { Media } from '@noths/polaris-client-ribbons-design-system';
import { Navigation } from '@noths/polaris-dev-ts-types';

import { Accordion, AccordionProps } from 'src/components/molecules/Accordion';
import * as styles from '../styles';
import { AccordionContent } from './AccordionContent';

const hasCategoryDescription = (categoryDescription: string) =>
  categoryDescription && categoryDescription !== '<p></p>';

interface Props {
  categoryDescription: string;
  navigation: Navigation[];
  categoryHeading: string;
  navigatedFromOrToPageOne: boolean;
  openOnMount: boolean;
}

/*
  HeaderCopyBlock renders Accordion both open and shut initially.
  The browser displays the appropriate view by leveraging media queries.
  Fresnel then subsequently changes this to conditional rendering:
  - This prevents life-cycle methods from firing in hidden components and unused html being written to the DOM.
*/
export const HeaderCopyBlock: FunctionComponent<Props> = ({
  categoryDescription,
  navigation,
  categoryHeading,
  navigatedFromOrToPageOne,
  openOnMount,
}: Props) => {
  const accordionProps: AccordionProps = {
    buttonStyles: styles.copyBlockAccordionButton,
    titleStyles: styles.pageHeadingFontCSS,
    id: 'copy-block',
    headingLevel: 'h1',
    title: categoryHeading,
  };
  const accordionContentProps = {
    categoryDescription,
    navigation,
    enableCopyBlockContent: navigatedFromOrToPageOne,
  };

  return (
    <div css={styles.pageHeadingCSS}>
      {hasCategoryDescription(categoryDescription) || navigation[0] ? (
        <>
          <Media lessThan={Breakpoint.L}>
            <Accordion {...accordionProps} isOpen={false}>
              <AccordionContent {...accordionContentProps} />
            </Accordion>
          </Media>
          <Media greaterThanOrEqual={Breakpoint.L}>
            <Accordion {...accordionProps} isOpen={openOnMount}>
              <AccordionContent {...accordionContentProps} />
            </Accordion>
          </Media>
        </>
      ) : (
        <div css={styles.pageHeadingWrapperCSS}>
          <h1>{categoryHeading}</h1>
        </div>
      )}
    </div>
  );
};
